/* eslint-disable react/prop-types */
import React from "react";
import { updateCallback } from "../../../hooks/update-hooks/update-callbacks/update-callback";
import { toast } from "react-toastify";
function LostDropdown({ callback, refetch }) {
    const [selctedStatus, setSelctedStatus] = React.useState(callback?.additionalDetails?.lost);
    const changeStatus = async (e) => {
        setSelctedStatus(e.currentTarget.value);
        let additionalDetails = callback?.additionalDetails
        additionalDetails.lost = e.currentTarget.value
        if (e.currentTarget.value === "NA") {
            additionalDetails.lostReason = "NA"
        }
        callback.additionalDetails = additionalDetails;
        try {
            await updateCallback({
                additionalDetails
            }, parseInt(callback.id))
            refetch()
        } catch (error) {
            toast.error(error)
        }

    }
    return (
        <select className="bg-white-50 rounded-md w-[120px] h-10 font-medium" onChange={(e) => changeStatus(e)} value={selctedStatus} name="status" id="status">
            <option value="NA" >NA</option>
            <option value="PRX_LOST" >PRX Lost</option>
            <option value="QUOTE_REJECTED">Quote Rejected</option>
        </select>
    );


}

export { LostDropdown };